import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import ConsoleView from '../views/console/ConsoleView.vue'
import LoginView from '../views/other/LoginView.vue'
import UserLog from '../views/console/UserLog.vue'
import DockKeyView from '../views/console/DockKeyView.vue'
import WithdrawalView from '../views/console/WithdrawalView.vue'
import AdminWithdrawal from '../views/admin/AdminWithdrawal.vue'
import AdminIndex from '../views/admin/AdminIndex.vue'
import QueryView from '../views/other/QueryView.vue'
import DevelopIndex from '../views/development/DevelopIndex.vue'
import ProductManage from '../views/development/ProductManage.vue'
import VersionLog from '../views/development/VersionLog.vue'
import FreeBenefits from '../views/other/FreeBenefits.vue'
import AlipayDMF from '../views/pay/AlipayDMF.vue'
import ShopAlipayDMF from '../views/pay/ShopAlipayDMF.vue'
import CarmineList from '@/views/carmine/CarmineList.vue'
import CarmineUse from '@/views/carmine/CarmineUse.vue'
import NoticeManage from '@/views/development/NoticeManage.vue'
import AdminLogin from '@/views/admin/AdminLogin.vue'
import DataManage from '@/views/development/DataManage.vue'
import UserManage from '@/views/other/UserManage.vue'
import IndexView from '@/views/index/Index.vue'
import AboutView from '@/views/index/About.vue'
import NoticeView from '@/views/index/NoticeView.vue'
import AgentListView from '@/views/index/AgentList.vue'
import ShopHome from '@/views/shop/ShopHome.vue'
import ShopDetail from '@/views/shop/ShopDetail.vue'
import ShopOrders from '@/views/shop/ShopOrders.vue'
import ShopInfoView from '@/views/console/ShopInfoView.vue'
import PayChannelView from '@/views/console/PayChannelView.vue'
import OrderManageView from '@/views/console/OrderManageView.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: IndexView,
    meta: { title: '易售SUP授权站' },
  }, {
    path: '/console',
    name: 'Console',
    component: ConsoleView,
    meta: { title: '控制台--易售SUP授权站' },
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView,
    meta: { title: '关于我们--易售SUP授权站' },
  },
  {
    path: '/userLog',
    name: 'UserLog',
    component: UserLog,
    meta: { title: '操作日志--易售SUP授权站' },
  },
  {
    path: '/query',
    name: 'Query',
    component: QueryView,
    meta: { title: '授权查询--易售SUP授权站' },
  },
  {
    path: '/freeBenefits',
    name: 'FreeBenefits',
    component: FreeBenefits,
    meta: { title: '免费授权--易售SUP授权站' },
  },
  {
    path: '/develop',
    name: 'Develop',
    component: DevelopIndex,
    meta: { title: '数据中心--开发中心' },
  },
  {
    path: '/productManage',
    name: 'ProductManage',
    component: ProductManage,
    meta: { title: '产品管理--开发中心' },
  }, {
    path: '/DataManage',
    name: 'DataManage',
    component: DataManage,
    meta: { title: '数据管理--开发中心' },
  },
  {
    path: '/NoticeManage',
    name: 'NoticeManage',
    component: NoticeManage,
    meta: { title: '公告管理--开发中心' },
  },
  {
    path: '/CarmineList',
    name: 'CarmineList',
    component: CarmineList,
    meta: { title: '卡密列表--卡密管理' },
  },
  {
    path: '/CarmineUse',
    name: 'CarmineUse',
    component: CarmineUse,
    meta: { title: '使用卡密--卡密管理' },
  },
  {
    path: '/alipayDMF',
    name: 'alipayDMF',
    component: AlipayDMF,
    meta: { title: '支付宝扫码支付--易售SUP授权站' },
  },
  {
    path: '/shopAlipayDMF',
    name: 'shopAlipayDMF',
    component: ShopAlipayDMF,
    meta: { title: '支付宝扫码支付--小店' },
  },
  {
    path: '/includesList',
    name: 'IncludesList',
    component: () => import(/* webpackChunkName: "about" */ '../views/other/IncludesList.vue'),
    meta: { title: '插件列表--易售SUP授权站' },
  },
  {
    path: '/agentEmpower',
    name: 'AgentEmpower',
    component: () => import(/* webpackChunkName: "about" */ '../views/other/AgentEmpower.vue'),
    meta: { title: '代理中心--易售SUP授权站' },
  },
  {
    path: '/userManage',
    name: 'UserManage',
    component: UserManage,
    meta: { title: '用户管理--易售SUP授权站' },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '登录--易售SUP授权站' },
  },
  {
    path: '/dockKey',
    name: 'DockKey',
    component: DockKeyView,
    meta: { title: '对接API--易售SUP授权站' },
  },
  {
    path: '/withdrawal',
    name: 'WithdrawalView',
    component: WithdrawalView,
    meta: { title: '提现记录--易售SUP授权站' },
  },
  {
    path: '/VersionLog',
    name: 'VersionLog',
    component: VersionLog,
    meta: { title: '版本管理--开发中心' },
  },
  {
    path: '/admin/withdrawal',
    name: 'AdminWithdrawal',
    component: AdminWithdrawal,
    meta: { title: '提现审核--后台中心' },
  },
  {
    path: '/admin/',
    name: 'AdminIndex',
    component: AdminIndex,
    meta: { title: '首页--后台中心' },
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { title: '管理员--登录' },
  },
  {
    path: '/Notice',
    name: 'NoticeView',
    component: NoticeView,
    meta: { title: '公告页面' },
  },
  {
    path: '/agentList',
    name: 'AgentList',
    component: AgentListView,
    meta: { title: '代理用户--易售SUP授权站' },
  },
  {
    path: '/shop',
    name: 'ShopHome',
    component: ShopHome,
    meta: { title: '小店--易售SUP授权站' },
  },
  {
    path: '/shopDetail',
    name: 'ShopDetail',
    component: ShopDetail,
    meta: { title: '商品详情--易售SUP授权站' },
  },
  {
    path: '/shopOrders',
    name: 'ShopOrders',
    component: ShopOrders,
    meta: { title: '订单查询--易售SUP授权站' },
  },
  {
    path: '/shopInfo',
    name: 'ShopInfo',
    component: ShopInfoView,
    meta: { title: '小店信息--易售SUP授权站' },
  },
  {
    path: '/payChannel',
    name: 'PayChannel',
    component: PayChannelView,
    meta: { title: '支付通道--易售SUP授权站' },
  },
  {
    path: '/orderManage',
    name: 'OrderManage',
    component: OrderManageView,
    meta: { title: '订单管理--易售SUP授权站' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 添加全局守卫
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title as string) || '易售SUP授权站';
  next();
});
export default router
